import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import routesReducer from './slices/routesSlice'
import eventsReducer from './slices/eventsSlice'
import activityReducer from './slices/activitySlice'
import adminReducer from './slices/adminSlice'
import organizerReducer from './slices/organizerSlice'
import sponsorReducer from './slices/sponsorSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    routes: routesReducer,
    events: eventsReducer,
    activity: activityReducer,
    admin: adminReducer,
    organizer: organizerReducer,
    sponsor: sponsorReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
})

export default store
